import React from "react"
import classNames from "classnames"

import Figure from "./figure"

import styles from "./postSidebar.module.scss"

const PostSidebar = ({ children, logo, className }) => (
  <aside className={classNames(styles.postSidebar, className)}>
    {children}
    {logo && (
      <div className={styles.postSidebarLogo}>
        <Figure {...logo} />
      </div>
    )}
  </aside>
)

export default PostSidebar
